import { render } from "./ManagersPage.vue?vue&type=template&id=9eb49aba"
import script from "./ManagersPage.vue?vue&type=script&lang=js"
export * from "./ManagersPage.vue?vue&type=script&lang=js"

import exportComponent from "/srv/www/nahodka.xpage.dev/htdocs/public/local/client-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__